import {
  DERIVED_ITEM_SCHEME_CHECKBOX_CHANGE,
  DERIVED_ITEM_SCHEME_CREATE_CHANGE,
  DERIVED_ITEM_SCHEME_CREATE_HIDE,
  DERIVED_ITEM_SCHEME_CREATE_SHOW,
  DERIVED_ITEM_SCHEME_ITEM_SELECT,
  DERIVED_ITEM_SCHEME_ITEMS_ADD,
  DERIVED_ITEM_SCHEME_ITEMS_REMOVE,
  DERIVED_ITEM_SCHEME_STATE_RESET
} from "./actions";
import {getMappedTree, getMaxTreeDepth, getNode, getNodes} from "../../utils/tree";
import _ from "lodash";

const derivedItemSchemeReducer = (
  state = {
    derivedItemScheme: null,
    derivedItemSchemeItems: null,
    derivedItemSchemeItemsTree: null,
    derivedItemSchemeItemsTreeMaxDepth: null,
    importCheckbox: {
      preserveHierarchy: true,
      importParents: true,
      importChildren: false,
      importDescendants: false
    },
    isCreateVisible: false,
    selectedSourceItems: null,
    selectedTargetItems: null
  },
  action
) => {
  switch (action.type) {
    case DERIVED_ITEM_SCHEME_ITEM_SELECT: {
      return {
        ...state,
        selectedSourceItems: action.isSource
          ? action.selectedArr
          : state.selectedSourceItems,
        selectedTargetItems: !action.isSource
          ? action.selectedArr
          : state.selectedTargetItems
      };
    }
    case DERIVED_ITEM_SCHEME_ITEMS_ADD: {

      let oldItems = state.derivedItemSchemeItems || [];

      // create array of new items from itemTree
      let itemsToAdd = getNodes(action.itemTree, action.childrenKey, node => state.selectedSourceItems.includes(node.id));

      if (action.forcePreserveHierarchy || state.importCheckbox.preserveHierarchy) {

        const relatedItemsToAdd = [];

        if (!action.forcePreserveHierarchy) {

          if (state.importCheckbox.importParents) {

            itemsToAdd.forEach(child => {

              const importParent = node => {
                if (node.parent) {
                  // get parent node
                  const parent = getNode(action.itemTree, action.childrenKey, ({id}) => id === node.parent);

                  if ([...oldItems, ...itemsToAdd, ...relatedItemsToAdd].find(alreadyAdded => alreadyAdded.id === parent.id) === undefined) {
                    // parent wasn't already added
                    relatedItemsToAdd.push(parent);
                  }

                  // recursively add parents
                  importParent(parent);
                }
              };

              importParent(child);
            });
          }

          if (state.importCheckbox.importChildren) {
            itemsToAdd.forEach(par =>
              (par[action.childrenKey] || []).forEach(child => {
                const oldItem = oldItems.find(oldItem => oldItem.id === child.id);
                if (oldItem) {
                  // child already exists in oldItems
                  oldItem.parent = par.id;
                } else if ([...itemsToAdd, ...relatedItemsToAdd].find(el => el.id === child.id) === undefined) {
                  // add children if not already exist
                  relatedItemsToAdd.push(child);
                }
              }));
          }

          if (state.importCheckbox.importDescendants) {
            itemsToAdd.forEach(root => relatedItemsToAdd.push(
              // add descendants if not already exist
              ...getNodes(
                [root],
                action.childrenKey,
                node =>
                  [
                    ...oldItems,
                    ...itemsToAdd,
                    ...relatedItemsToAdd
                  ].find(({id}) => id === node.id) === undefined
              )));
          }
        }

        itemsToAdd = [...itemsToAdd, ...relatedItemsToAdd];

        // bring to root new items that will not have original parent in the new array
        itemsToAdd = itemsToAdd.map(item => ({
          ...item,
          parent: [...oldItems, ...itemsToAdd].find(parent => parent.id === item.parent) ? item.parent : null
        }));

      } else {

        // bring to root any new item
        itemsToAdd = itemsToAdd.map(item => ({
          ...item,
          parent: null
        }));
      }

      // create array of items
      const newDerivedItemSchemeItems = [...oldItems, ...itemsToAdd];

      // create tree from array of items
      const newDerivedItemSchemeItemsTree = getMappedTree(
        newDerivedItemSchemeItems.filter(({parent}) => !parent),
        action.childrenKey,
        node => ({
          ...node,
          [action.childrenKey]: newDerivedItemSchemeItems.filter(item => item.parent === node.id)
        })
      );

      return {
        ...state,
        derivedItemSchemeItems: newDerivedItemSchemeItems,
        derivedItemSchemeItemsTree: newDerivedItemSchemeItemsTree,
        derivedItemSchemeItemsTreeMaxDepth: getMaxTreeDepth(newDerivedItemSchemeItemsTree, action.childrenKey),
        selectedSourceItems: null
      };

    }
    case DERIVED_ITEM_SCHEME_ITEMS_REMOVE:

      // remove items from array
      const newDerivedItemSchemeItems = state.derivedItemSchemeItems.filter(({id}) => !action.items.includes(id));

      // create tree from array of items
      const newDerivedItemSchemeItemsTree = getMappedTree(
        newDerivedItemSchemeItems.filter(({parent}) => !parent),
        action.childrenKey,
        node => ({
          ...node,
          [action.childrenKey]: newDerivedItemSchemeItems.filter(item => item.parent === node.id)
        })
      );

      return {
        ...state,
        derivedItemSchemeItems: newDerivedItemSchemeItems,
        derivedItemSchemeItemsTree: newDerivedItemSchemeItemsTree,
        derivedItemSchemeItemsTreeMaxDepth: getMaxTreeDepth(newDerivedItemSchemeItemsTree, action.childrenKey),
        selectedTargetItems: null
      };
    case DERIVED_ITEM_SCHEME_CHECKBOX_CHANGE:
      return {
        ...state,
        importCheckbox: _.merge(state.importCheckbox, action.checkbox)
      };
    case DERIVED_ITEM_SCHEME_CREATE_SHOW:
      return {
        ...state,
        isCreateVisible: true,
        derivedItemScheme: {
          id: null,
          agencyID: null,
          version: null,
          name: null
        }
      };
    case DERIVED_ITEM_SCHEME_CREATE_HIDE:
      return {
        ...state,
        isCreateVisible: false
      };
    case DERIVED_ITEM_SCHEME_CREATE_CHANGE:
      const derivedItemScheme = _.cloneDeep(state.derivedItemScheme);

      return {
        ...state,
        derivedItemScheme: _.merge(derivedItemScheme, action.fields)
      };
    case DERIVED_ITEM_SCHEME_STATE_RESET:
      return {
        ...state,
        derivedItemScheme: null,
        derivedItemSchemeItems: null,
        derivedItemSchemeItemsTree: null,
        derivedItemSchemeItemsTreeMaxDepth: null,
        importCheckbox: {
          preserveHierarchy: true,
          importParents: true,
          importChildren: false,
          importDescendants: false
        },
        isCreateVisible: false,
        selectedSourceItems: null,
        selectedTargetItems: null
      };
    default:
      return state;
  }
};

export default derivedItemSchemeReducer;